// UPDATE the component:

import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import NotificationComponent from '../NotificationComponent/NotificationComponent';
import { selectNotifications, removeNotification } from '../../redux/slices/notificationSlice';

// UPDATE the className:

const GlobalNotifications = () => {
    const notifications = useSelector(selectNotifications);
    const dispatch = useDispatch();

    // Auto-remove notifications after their duration
    useEffect(() => {
        const timers = notifications
            .filter(notification => notification.autoClose)
            .map(notification => {
                return setTimeout(() => {
                    dispatch(removeNotification(notification.id));
                }, notification.duration);
            });

        return () => {
            timers.forEach(timer => clearTimeout(timer));
        };
    }, [notifications, dispatch]);

    if (notifications.length === 0) {
        return null; // Don't render container if no notifications
    }

    return (
        <div className="global-notifications-container"> {/* This will use the centered positioning */}
            {notifications.map((notification, index) => (
                <div key={`notification-${notification.id}`} style={{ zIndex: 10001 + index }}>
                    <NotificationComponent
                        notificationData={{
                            show: true,
                            type: notification.type,
                            message: notification.message,
                            isInline: notification.isInline
                        }}
                        onClose={() => dispatch(removeNotification(notification.id))}
                    />
                </div>
            ))}
        </div>
    );
};

export default GlobalNotifications;